import { FC, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@material-ui/core';
import './expiredtokenmodal.scss';
import { useIdleTimer } from 'react-idle-timer';

type ExpiredTokenModalProps = {
    timeout: number;
    promptBeforeIdle: number;
    onLogout: () => void;
};

export const ExpiredTokenModal: FC<ExpiredTokenModalProps> = ({ timeout, promptBeforeIdle, onLogout }) => {
    const [showExpiredTokenModal, setShowExpiredTokenModal] = useState(false);

    const { activate } = useIdleTimer({
        onIdle: onLogout,
        onActive: () => setShowExpiredTokenModal(false),
        onPrompt: () => setShowExpiredTokenModal(true),
        timeout,
        promptBeforeIdle,
        throttle: 500,
    });

    const styles = {
        modal: {
            width: 400,
        },
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
    };

    return (
        <Dialog
            maxWidth='lg'
            open={showExpiredTokenModal}
            onClose={() => activate()}
            aria-labelledby='form-dialog-title'
            style={{ zIndex: 10000 }}
        >
            <div className='modal-container expired-token-modal'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    role='dialog'
                    style={styles.modal}
                >
                    <div className='modal-dialog'>
                        <div
                            className='page-header'
                            role='banner'
                        >
                            <h1>Session about to expire!</h1>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                                aria-label='Close'
                                onClick={() => activate()}
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='modal-content'>
                            Your session is about to expire. You will be logged out in 5 minutes. To continue your session, select
                            Continue Working.
                        </div>
                    </div>
                    <div
                        className='modal-footer modal-actions'
                        style={styles.buttonContainer}
                    >
                        <Button
                            id='continueButton'
                            color='primary'
                            variant='contained'
                            style={styles.buttonMarginRight}
                            onClick={() => activate()}
                        >
                            Continue Working
                        </Button>
                        <Button
                            id='logoutButton'
                            color='secondary'
                            variant='contained'
                            onClick={onLogout}
                        >
                            Log Out
                        </Button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
